import { cssBaseAntPagination } from "@/styles/css"
import { Pagination } from "antd"
import tw, { styled } from "twin.macro"
import Icon from "../Icon"
import { includes } from "lodash"

const StyledPagination = styled(Pagination)(() => [cssBaseAntPagination])

export default function CustomPagination(props) {
    return (
        <StyledPagination
            showSizeChanger={false}
            {...props}
            itemRender={(page, type, el) => {
                if (includes(["next", "prev"], type)) {
                    return (
                        <Icon
                            name="arrow_left"
                            color="currentColor"
                            sizes={[7.5, 13.33]}
                            tw="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                            css={[type === "prev" && tw`transform rotate-180`]}
                        />
                    )
                }
                return el
            }}
        />
    )
}
